import { AccountsPayableResource, PayrollResource, EmployeeResource, DepositAccountResource } from '@sigmacloud/sigma-client/dist/resources'

// {{url}}/typedexports?type=PR_NACHA_DD&page_size=10&page=1&timestamp__gte=2022-02-25T00:00:0.000000Z
export default class CustomAccountsPayableResource extends AccountsPayableResource {
  static related = {
    payroll: PayrollResource,
    employee: EmployeeResource,
    deposit_account: DepositAccountResource
  }
}
